/**
 * Maximum message body length in characters (PRD R4). Enforced three times:
 * the composer caps input (UX), the controller refuses oversized sends
 * (defense in depth), and Costanza rejects oversized bodies server-side —
 * the guarantee: this composer is the only client, but the endpoint itself
 * accepts raw XMPP from anything holding a valid session token.
 */
export const MAX_MESSAGE_LENGTH = 4_000

/**
 * Largest image the composer uploads. Checked before uploading, so an
 * oversized file is refused at once rather than after the wait.
 */
export const MAX_ATTACHMENT_BYTES = 10 * 1024 * 1024
